function createMarquee(containerSelector, itemSelector, duration, gap) {
    const marqueeContainer = document.querySelector(containerSelector);
    let marqueeItems = Array.from(marqueeContainer.querySelectorAll(itemSelector));
    marqueeContainer.style.whiteSpace = 'nowrap';

    let itemsWidth = marqueeItems.reduce((accum, item) => accum + item.offsetWidth, 0);

    while (itemsWidth < marqueeContainer.offsetWidth * 2 || itemsWidth < window.innerWidth) {
        marqueeItems.forEach((item) => {
            const clone = item.cloneNode(true);
            marqueeContainer.appendChild(clone);
        });

        marqueeItems = Array.from(marqueeContainer.querySelectorAll(itemSelector));
        itemsWidth = marqueeItems.reduce((accum, item) => accum + item.offsetWidth, 0);
    }

    marqueeItems.forEach((item) => {
        item.style.marginRight = `${gap}px`;
    });

    (function loop() {
        const anim = marqueeContainer.animate([ { transform: "translate(0, 0)" }, { transform: `translate(-${itemsWidth}px, 0)` }], {
            duration: itemsWidth * duration,
            iterations: Infinity,
        });
    })();
}

export { createMarquee };

